export const bytebinUrl =
  process.env.REACT_APP_BYTEBIN_URL || 'https://bytebin.happyareabean.cc/';

export const postUrl = bytebinUrl + 'post';
